import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";

import { CommitteePosition, CommitteeTypeEnum } from "../Committee";
import { Role } from "../Shared/Role";
import { User } from "./User";

export interface UserPermission extends CodeBook {
    user: User;
    canImpersonate: boolean;
    rolePermissions?: Role[];
    locations?: number[];
    committeeMemberships: CommitteeMember[];
    claimType: ClaimType;
    role: number;

    impersonator?: UserPermission;
}

export enum ClaimType
{
    Institution = 1,
    County,
    Role,
    Global,
}

export interface CommitteeMember {
    committeeId: number;
    committeeType: CommitteeTypeEnum;
    institutionId?: number;
    countyId?: number;
    committeePosition: CommitteePosition;
    isPresident: boolean;
    committeeEmployeeId: number;
    committeeRoleId: number; // These roles cannot be an enum.
    isCroatianLanguageTeacher: boolean;
}